export const UPDATE_INFORMATION = "UPDATE_INFORMATION";

export const ADD_QUESTION = "ADD_QUESTION";
export const UPDATE_QUESTION = "UPDATE_QUESTION";
export const REMOVE_QUESTION = "REMOVE_QUESTION";

export const ADD_ANSWER = "ADD_ANSWER";
export const REMOVE_ANSWER = "REMOVE_ANSWER";
export const UPDATE_ANSWER = "UPDATE_ANSWER";

export const RESET_QUIZ = "RESET_NEW_QUIZ";
export const PUSH_QUIZ = "PUSH_QUIZ";
export const SET_QUIZ = "SET_QUIZ";
export const RESET_QUIZ_LIST = "RESET_QUIZ";

export const ADD_QUIZ = "ADD_QUIZ";
export const REMOVE_QUIZ = "REMOVE_QUIZ";
export const UPDATE_QUIZ = "UPDATE_QUIZ";

export const SET_CLIENT = "SET_CLIENT";
export const SET_CLIENT_LIST = "SET_CLIENT_LIST";



// WEBPACK FOOTER //
// ./src/store/quiz/mutations.js